import React from "react";
import SaleLandingPageCategoriesRail from "web/react/components/sale-landing-page-categories-rail/sale-landing-page-categories-rail";
import HomepageProductRail from "web/react/components/homepage-product-rail/homepage-product-rail";
import ProductTypeIndex from "web/react/components/product-type-index/product-type-index";
import HomepageDesignerRail from "web/react/components/homepage-designer-rail/homepage-designer-rail";
import SteppedGuide from "web/react/components/step-guide/step-guide";
import SaleLandingPageLink from "web/react/components/sale-landing-page-link/sale-landing-page-link";
import FeaturedBanners from "web/react/components/featured-banners/featured-banners";
import SaleLandingHeader from "web/react/components/sale-landing-header/sale-landing-header";
import styles from "./sale-landing-page-layout.css";

interface SaleLandingPageLayoutProps {
    layoutData: any;
}

export function SaleLandingPageLayout({
    layoutData: {
        header_title: headerTitle,
        sale_page_categories: categories,
        sale_page_designers: designers,
        product_type_index: productIndex,
        opposite_gender_link: oppositeGenderLink,
        sale_page_offers: offersOfTheWeek,
        sale_page_featured_banners: featuredBanners,
        sale_page_guide: saleGuide,
    },
}: SaleLandingPageLayoutProps): JSX.Element {
    return (
        <div className={styles.main}>
            <SaleLandingHeader title={headerTitle} />
            {productIndex && <ProductTypeIndex links={productIndex.links} />}
            {designers && (
                <HomepageDesignerRail
                    items={designers.links}
                    analyticsLabel={"sale_landing_page_designers_rail"}
                />
            )}
            {categories && <SaleLandingPageCategoriesRail items={categories.links} />}
            {oppositeGenderLink && (
                <div className={styles.oppositeGenderLinkWrapper}>
                    <SaleLandingPageLink item={oppositeGenderLink} type={"opposite-gender"} />
                </div>
            )}
            {offersOfTheWeek && offersOfTheWeek.products.length && (
                <HomepageProductRail
                    title={offersOfTheWeek.title}
                    products={offersOfTheWeek.products}
                />
            )}

            {saleGuide && <SteppedGuide {...saleGuide} />}

            {featuredBanners && <FeaturedBanners {...featuredBanners} />}
        </div>
    );
}

export default SaleLandingPageLayout;
